<template>
  <v-dialog v-model="userDialog" width="320">
    <template v-slot:activator="{ on }">
      <v-btn
      v-on="on"
      text
      >
      <span class="mr-2 d-none d-sm-block">{{activatorLabel}}</span>
      <v-icon>fa-user</v-icon>
    </v-btn>

    <span class="tfn"><a href="tel:801-972-5845">(801) 972-5845</a></span>
  </template>
  <v-card v-if="!loggedIn">
    <v-card-title class="d-flex justify-center">
      <span class="headline">Reseller Login</span>
    </v-card-title>
    <v-card-text>
      <v-alert
      v-if="errorMsg"
      dense
      outlined
      type="error"
      icon="fa-warning"
      >
      {{errorMsg}}
    </v-alert>
    <v-text-field label="Customer ID" v-model="username" required :rules="requiredRule" ></v-text-field>
    <v-text-field label="Password" v-model="password" type="password" required :rules="requiredRule" ></v-text-field>
  </v-card-text>
  <v-card-actions class="d-flex justify-center">
    <v-form v-model="valid" ref="form">
      <v-btn text @click="userDialog = false">Cancel</v-btn>
      <v-btn color="primary" @click="login">Login</v-btn>
    </v-form>
  </v-card-actions>
</v-card>
<v-card v-if="loggedIn">
  <v-card-title class="d-flex justify-center">
    <span class="headline">Choose Price Display</span>
  </v-card-title>
  <v-card-text>
    <v-radio-group v-model="pricing">
      <v-radio
      label="None"
      value=""
      ></v-radio>
      <v-radio
      label="Retail"
      value="retailPrice"
      ></v-radio>
      <v-radio
      :label="isFleet"
      value="wholesale"
      ></v-radio>
    </v-radio-group>
  </v-card-text>
  <v-card-actions class="d-flex justify-center">
    <v-btn color="primary" @click="userDialog = false">Close</v-btn>
  </v-card-actions>
</v-card>
</v-dialog>
</template>

<style scoped>
  .v-card__actions {
    padding: 16px;
  }

  .v-dialog__content {
    align-items: flex-start;
    justify-content: flex-end;
  }
</style>

<script>
  import { mapState } from 'vuex'
  import { requiredRule } from '@/utils'
  import Token from '@/services/token'
  import Customer from '@/services/customer'
  import Addresses from '@/services/addresses'

  export default {
    data () {
      return {
        requiredRule,
        valid: false,
        userDialog: false,
        loggedIn: false,
        username: null,
        password: null,
        errorMsg: ''
      }
    },
    computed: {
      ...mapState([
        'customer'
        ]),
      pricing: {
        get () {
          return this.$store.state.pricing
        },
        set (pricing) {
          this.$store.commit('setPricing', pricing)
        }
      },
      activatorLabel: function() {
        return this.loggedIn ? 'Change Pricing View' : 'Reseller / Fleet Login'
      },
      getDiscountIndex: function () {
        return this.$store.state.customer.discountIndex
      },
      isFleet: function() {
        return this.getDiscountIndex === 4 ? 'Fleet' : 'Wholesale'
      },
    },
    methods: {
      validate () {
        return this.$refs.form.validate()
      },
      login: function() {
        this.errorMsg = ''
        if (this.validate()) {
          Token.get(this.username, this.password)
          .then(this.loadCustomer)
          .catch(this.handleError)
        }
      },
      loadCustomer: function(data) {
        Addresses
        .get(data.customer_id, data.access_token)
        .then(this.save)
        Customer
        .get(data.customer_id, data.access_token)
        .then(this.success)
        .catch(this.handleError)
      },
      save: function(addresses) {
        this.$store.commit('setAddresses', addresses)
      },
      success: function(customer) {
        this.$store.commit('setCustomer', customer)
        this.loggedIn = true
      },
      handleError(error) {
        this.errorMsg = error.response.data.error_description
      // console.error('err', error)
    }
  }
}
</script>

<style lang="scss">
  .mr-2 {
    margin-top: 3px !important;
  }

  .tfn {
    font-weight: 600;
    position: relative;
    top: 1px;
    display: none;
    a {
      color: $white !important;
      text-decoration: none;
    }

    &::after {
      content: "|";
      color: $white;
      padding-left: 12px;
    }

    @media screen and (min-width: 600px) {
      display: block;
    }
  }
</style>
